import { observable } from 'mobx'
import { task } from 'mobx-task'
import { type Job } from '@/features/jobs/Job'
import { type JobStore } from '@/features/jobs/JobStore'
import type { AlertErrorHandlerFactory } from '@/features/shell'
import { ModalViewModel } from '@/infra/ModalViewModel'

/**
 * View model for the dialog confirming that a job's info gathering is
 * complete.
 */
export class CompleteInfoGatheringDialogViewModel {
  readonly modal = new ModalViewModel()

  /**
   * Whether an admin bypasses the required items.
   */
  @observable accessor completeAsAdmin = false

  constructor(
    private readonly _job: Job,
    private readonly _jobStore: JobStore,
    private readonly _createAlertErrorHandler: AlertErrorHandlerFactory,
  ) {}

  /**
   * Completes the info gathering step, closing the dialog either way.
   */
  complete = task.resolved(async () => {
    try {
      await this._jobStore
        .completeInfoGathering(this._job.id, this.completeAsAdmin)
        .catch(
          this._createAlertErrorHandler('Completing info gathering failed'),
        )
    } finally {
      this.modal.close()
    }
  })
}
